import { Component, Input } from '@angular/core';
import { AttentionModel } from 'app/models/shared/attention.model';
import { ConfirmModel } from 'app/models/shared/confirm.model';
import { LoadingModel } from 'app/models/shared/loading.model';
import { TooltipModel } from 'app/models/shared/tooltip.model';
import { EventService } from 'app/services/event.service';
import { LAYOUT_PART } from 'app/shared/constants';
import { AppPageEnum, EventName, TooltipNameEnum } from 'app/shared/enums';
import { tMatchingActionType, tMatchingSectionType } from 'app/types/statement.const.type';

@Component({
    selector: 'app-base-component',
    template: '',
    standalone: false
})
export class BaseComponent  {
    @Input() page!: AppPageEnum;
    @Input() toolTipName!: TooltipNameEnum;

    appPageEnum = AppPageEnum
    tooltipNameEnum = TooltipNameEnum;
    
    loadingData = new LoadingModel({ 
        visible: false,
        position: { of: LAYOUT_PART.body}
    });

    attentionData = new AttentionModel({
        visible: false,
        message: ''
    });

    constructor(protected eventService: EventService, page: AppPageEnum | null) {
        if (page)
            this.page = page;
    }

    showTooltip(event: MouseEvent, name: TooltipNameEnum | string, content?: string) {
    // skipcq: JS-0323
        const target = (event.currentTarget ?? (event as any).toElement) as HTMLElement;
        
        this.eventService.broadcast(EventName.ShowTooltip, new TooltipModel(target, {
            page: this.page,
            name,
            content
        }));
    }

    showAttention(section: tMatchingSectionType, matchType: tMatchingActionType, message: string, blocking = false, isAlert = false, buttonText = '', layoutPart = LAYOUT_PART.body) {
        this.attentionData.visible = true;
        this.attentionData.message = message;
        this.attentionData.container = layoutPart;
        this.attentionData.blocking = blocking;
        this.attentionData.isAlert = isAlert;
        this.attentionData.buttonText = buttonText;
        this.attentionData.action = matchType;
        this.attentionData.section = section;
        this.attentionData.confirmAttentionScope = this.page;
        this.eventService.broadcast(EventName.ShowAttention, this.attentionData);
    }
    
    showLoading(layoutPart: string = LAYOUT_PART.body, shading = true) {
        this.loadingData.visible = true;
        this.loadingData.position = {
            of: layoutPart
        };
        this.loadingData.shading = shading;
        this.eventService.broadcast(EventName.ShowLoading, this.loadingData);
    }

    showConfirm(section: tMatchingSectionType, action: tMatchingActionType
        // skipcq: JS-0323
        , message: string, data: any, confirmResponseScope: AppPageEnum
        , includeNote = false, confirmBtnText = 'Confirm', cancelBtnText = 'Cancel', bigIcon = true, includeFiles = false, includeSubject = false) {
        this.eventService.broadcast(EventName.ShowConfirm, new ConfirmModel<tMatchingActionType, tMatchingSectionType>({
            container: '',
            visible: true,
            section,
            action,
            message,
            data,
            confirmResponseScope,
            includeNote,
            confirmBtnText,
            cancelBtnText,
            bigIcon,
            includeFiles,
            includeSubject
        }));
    }

    hideLoading() {
        this.loadingData.visible = false;
        this.eventService.broadcast(EventName.ShowLoading, this.loadingData);
    }
}
